module.exports = __webpack_public_path__ + "img/printer_ready.3c07ae2f.jpg";